import cfg from "../../../libs/client.json";

import {SvgDocToBitmap} from "../../../libs/convert";
import {Buffer} from "buffer";


let DesignUploadS3 = (svgDoc, svgDocOrigin, pathFile, bucket = cfg.s3.bucket, imgW = 600, imgH = 600) => {
    return new Promise(async (resolve, reject) => {
        let name = Date.now();
        let key = `${pathFile}/${name}`;

        let base64 = await SvgDocToBitmap(svgDocOrigin, Number(imgW), Number(imgH), 'png');
        let base64Data = new Buffer.from(base64.replace(/^data:image\/\w+;base64,/, ""), 'base64');

        let formData = new FormData();
        formData.append("image", new Blob([base64Data], { type: "image/png" }), "design-image.png");
        formData.append("svg", new Blob([svgDoc], { type: "image/svg+xml" }), "design.svg");

        try {
            let response = await fetch("https://tbs-api.cnttlct.workers.dev/add-to-admin-design", {
                method: "POST",
                body: formData
            });

            let result = await response.json();
            console.log("Upload Success:", result);
            resolve(result);
        } catch (error) {
            reject(error);
        }

    })

}


export {DesignUploadS3}